export default __webpack_public_path__ + "static/media/lottery-banners-cn.05a847c3.webp";